<template>
  <div>
    <template v-for="(item,i) in list">
      <v-card :key="'cart-item'+i" class="mt-2">
        <v-list three-line>
          <v-list-tile avatar style="margin-top:0px;margin-right:10px">
            <v-list-tile-avatar tile size="90">
              <img :src="src+'/Admin/'+item.image_path" @error="imageErr" style="padding-top: 15px;object-fit: contain"/>
            </v-list-tile-avatar>
            <v-list-tile-content class="pl-3">
              <div>
                {{item.item_name}}
                <v-chip
                  color="orange"
                  v-if="item.brand_name"
                  small
                  text-color="white"
                >{{item.brand_name}}</v-chip>
              </div>
              <v-list-tile-sub-title v-text="item.item_description"></v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-flex>
                <v-btn flat class="mr-2">Rs. {{item.price}}</v-btn>
                <v-btn icon @click="openCart(item)">
                  <v-icon color="green">add_shopping_cart</v-icon>
                </v-btn>
              </v-flex>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-card>
    </template>
    <v-dialog v-model="viewcart" width="400">
      <v-card>
        <v-card-title class="title">Enter Order Details</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-text-field class="mb-2" v-model="qty" solo hide-details label="Qty" type="number"></v-text-field>
          <v-text-field class="mb-2" v-model="name" solo hide-details label="Name" type="text"></v-text-field>
          <v-text-field class="mb-2" v-model="address" solo hide-details label="Address" type="text"></v-text-field>
          <v-text-field class="mb-2" v-model="pincode" solo hide-details label="Pin code" type="number"></v-text-field>
          <v-text-field
            class="mb-2"
            v-model="mobile"
            solo
            hide-details
            label="Mobile"
            type="number"
          ></v-text-field>
          <v-textarea v-model="remark" solo hide-details no-resize label="Remark"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat="flat" @click="viewcart = false">Cancel</v-btn>
          <v-btn color="green darken-1" flat="flat" @click="orderNow()">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props:{
    category: {
      type: Object,
      default: () =>{
        return {};
      }
    }
  },
  data() {
    return {
      list: [],
      viewcart: false,
      remark: "",
      qty: "",
      mobile: "",
      pincode: "",
      name: "",
      address: "",
      item: {}
    };
  },
  computed: {
    src() {
      return this.$store.getters.src;
    },
    user() {
      return this.$store.getters.user;
    }
  },
  watch: {
    category() {
      this.fetch();
    }
  },
  methods: {
    openCart(item) {
      const vm = this;
      vm.qty = "";
      vm.mobile = "";
      vm.remark = "";
      vm.pincode = "";
      vm.name = "";
      vm.address = "";
      vm.viewcart = true;
      vm.item = item;
    },
    imageErr(evt) {
      evt.target.src = require("../assets/shop.png");
    },
    fetch() {
      const vm = this;
      if (!vm.user.phone)
        return vm.$parent.notification("warn", "Authentication Required!");
      let doc = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        getFromdate: vm.date1,
        getTodate: vm.date2,
        Source: "json"
      };
      vm.$root.loader = true;
      let url = "Shopping_Item_List"
      let {shopping_category} = vm.category;
      if(shopping_category) {
        url = "Shopping_Item_List_ByCategory"
        doc.Category = shopping_category;

      }
      vm.$store
        .dispatch("axiosshop", {
          url: url,
          data: doc
        })
        .then(function(res) {
          vm.list = [];
          res.data.forEach(item => {
            if (item.isactive === "True") vm.list.push(item);
          });
          vm.$root.loader = false;
        })
        .catch(function(error) {
          vm.$parent.notification("error", error.message);
          vm.$root.loader = false;
        });
    },
    orderNow() {
      const vm = this;
      if (!vm.user.phone)
        return vm.$parent.notification("warn", "Authentication Required!");
      if (vm.qty === "")
        return vm.$parent.notification("warn", "Qty Required!");
      if (Number(vm.qty) < Number(vm.item.minimun_qty))
        return vm.$parent.notification(
          "warn",
          `Minimum required qty is ${vm.item.minimun_qty}`
        );
      if (vm.mobile === "")
        return vm.$parent.notification("warn", "Mobile Required!");
      if (vm.name === "")
        return vm.$parent.notification("warn", "Name Required!");
      if (vm.address === "")
        return vm.$parent.notification("warn", "Address Required!");
      if (vm.pincode === "")
        return vm.$parent.notification("warn", "Pincode Required!");
      if (vm.mobile.length !== 10)
        return vm.$parent.notification("warn", "Enter valid mobile number");
      let doc = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        ItemId: vm.item.autono,
        Qty: vm.qty,
        Remark: vm.remark,
        Customer_MobileNo: vm.mobile,
        Customer_Name:vm.name,
        Address: vm.address,
        PinCode: vm.pincode,
        Source: "json"
      };
      vm.$root.loader = true;
      vm.$store
        .dispatch("axiosshop", {
          url: "DoShopping",
          data: doc
        })
        .then(function(res) {
          vm.$root.loader = false;
          vm.viewcart = false;
          vm.$parent.notification("success", res.data.Message);
        })
        .catch(function(error) {
          vm.$parent.notification("error", error.message);
          vm.$root.loader = false;
        });
    }
  },
  mounted() {
    const vm = this;
    vm.fetch();
  }
};
</script>

<style>
</style>